import getUsedBlocksFromHTML from '../../blocks/helpers/get-used-blocks-from-html';
import actionTypes from '../constants/action-types';
import setPageUsedBlock from '../actions/set-page-used-block';
import getUsedBlocks from '../selectors/used-blocks';

const pageUsedBlocksTracker = (store) => (next) => (action) => {
  if (action.type === actionTypes.SET_PAGE_HTML) {
    const { html, pageId } = action.payload;
    const state = store.getState();
    const pageUsedBlocks = getUsedBlocks(state, pageId);
    const usedBlocks = getUsedBlocksFromHTML(html);

    if (
      pageUsedBlocks.length !== usedBlocks.length ||
      !usedBlocks.every((blockId) => pageUsedBlocks.includes(blockId))
    ) {
      store.dispatch(setPageUsedBlock(pageId, usedBlocks));
    }
  }

  next(action);
};

export default pageUsedBlocksTracker;
